import { useTheme } from '@mui/material';
import { BlueberrySizeDataModel } from '../types';
import { SegmentedBar } from './SegmentedBar';

export const BlueberrySizeChartSegmentedBar = ({
  data,
  fullBarValue: fullBarValue = 1,
}: {
  data: BlueberrySizeDataModel;
  fullBarValue?: number;
}) => {
  const theme = useTheme();

  const segments = [
    {
      value: data.green,
      color: theme.colors.canopy.components.barChart.green,
    },
    {
      value: data.yellow,
      color: theme.colors.canopy.components.barChart.pink,
    },
    {
      value: data.purple,
      color: theme.colors.canopy.components.barChart.purple,
    },
    {
      value: data.blue,
      color: theme.colors.canopy.components.barChart.blue,
    },
  ];

  return <SegmentedBar fullBarValue={fullBarValue} segments={segments} />;
};
